export default __webpack_public_path__ + "static/61362448_307093836875961_4748430993607504833_n-f398fbfb086615ff92217f599208aeca.jpg";